import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { Quote, PurchaseMethods, CurrencyFormats } from '@sm360/widget-commons-vehicle';

const { PurchaseMethodsService } = PurchaseMethods;

const GarageFinance = ({ quote }) => {
    const { vehicle } = quote;
    const { purchaseMethods } = vehicle;
    const purchaseMethodLabels = purchaseMethods.getPurchaseMethodLabels(LocaleService);
    const paymentFrequencyLabels = purchaseMethods.getPaymentFrequencyLabels(false, LocaleService);
    const selectedFinanceTerm = purchaseMethods.getSelectedFinanceTerm();
    const selectedPurchaseMethodAmounts = purchaseMethods.getSelectedPurchaseMethodAmounts();
    const rebates = (selectedPurchaseMethodAmounts.rebates || 0) + (selectedPurchaseMethodAmounts.discounts || 0);
    const calculatedFormattedRebates = rebates > 0 ? LocaleService.l(rebates, CurrencyFormats.CURRENCY_0) : '';

    let calculatedPayments;
    let apr = 0;
    let cashDown = 0;
    let months = '';

    if (selectedFinanceTerm) {
        calculatedPayments = selectedFinanceTerm.getCalculatedPayments(false);
        apr = selectedFinanceTerm.apr;
        cashDown = LocaleService.l(selectedFinanceTerm.cashDown, CurrencyFormats.CURRENCY_0);
        months = `${selectedFinanceTerm.term} ${LocaleService.t('purchaseMethods.monthsAbr')}`;
    }

    const calculatedFormattedPaymentBeforeTaxes =
        calculatedPayments && calculatedPayments.calculatedPaymentBeforeTaxes > 0
            ? LocaleService.l(calculatedPayments.calculatedPaymentBeforeTaxes, CurrencyFormats.CURRENCY_2)
            : '';
    const calculatedFormattedPaymentTaxes =
        calculatedPayments && calculatedPayments.calculatedPaymentBeforeTaxes > 0
            ? `${LocaleService.l(calculatedPayments.calculatedPaymentTaxes, CurrencyFormats.CURRENCY_2)}`
            : '';
    const calculatedFormattedPayment =
        calculatedPayments && calculatedPayments.calculatedPaymentBeforeTaxes > 0
            ? LocaleService.l(calculatedPayments.calculatedPayment, CurrencyFormats.CURRENCY_2)
            : '';

    const calculatedPaymentSplit = calculatedFormattedPaymentBeforeTaxes
        ? PurchaseMethodsService.getFormattedCurrencySplit(calculatedFormattedPaymentBeforeTaxes)
        : '';

    const paymentWithTaxes = `+ ${calculatedFormattedPaymentTaxes} = ${calculatedFormattedPayment}`;

    const formattedCashDown = LocaleService.t('DOWN_PAYMENTS.CASH_DOWN_WITH_AMOUNT', { cashDown });
    const tradeInAmount = LocaleService.l(purchaseMethods.tradeIn, CurrencyFormats.CURRENCY_0);
    const tradeInWithTaxCredits = LocaleService.l(
        purchaseMethods.getTradeInWithTaxCredits(),
        CurrencyFormats.CURRENCY_2
    );
    const taxCreditsAmount = LocaleService.l(
        purchaseMethods.getTradeInWithTaxCredits() - purchaseMethods.tradeIn,
        CurrencyFormats.CURRENCY_2
    );

    return (
        <div className="payment-wrapper">
            <p className="payment-title sr-text is-bold">{purchaseMethodLabels.verb}</p>
            <div className="payment-info">
                <p className="payment-price">
                    <span className="is-price sr-text is-bold">
                        {calculatedPaymentSplit.beforeDecimal}
                        <sup>{calculatedPaymentSplit.afterDecimal}</sup> &nbsp;
                        {paymentFrequencyLabels.perPeriod}
                    </span>{' '}
                    &nbsp;
                    {paymentWithTaxes}
                </p>
                <p className="payment-summary">
                    <span>
                        {apr.toFixed(2).split('.')[0]}
                        <sup>{apr.toFixed(2).split('.')[1]}%</sup>
                    </span>{' '}
                    &nbsp;
                    {months}
                </p>
                <p className="payment-account">{formattedCashDown}</p>
            </div>
            {rebates > 0 && (
                <div className="vehicle-rebate">
                    <icon className="icon-promo2 is-price" />
                    <p>
                        {LocaleService.t('GARAGE.VEHICLE_STATUS.BONUS_REBATE', { rebate: calculatedFormattedRebates })}
                    </p>
                </div>
            )}
            {purchaseMethods.tradeIn > 0 && (
                <div className="vehicle-rebate">
                    <icon className="icon-refresh is-util" />
                    <p>
                        {LocaleService.t('GARAGE.VEHICLE_STATUS.TRADE_IN', {
                            tradeInAmount,
                            taxCreditsAmount,
                            tradeInWithTaxCredits,
                        })}
                    </p>
                </div>
            )}
        </div>
    );
};

GarageFinance.propTypes = { quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired };

GarageFinance.displayName = 'GarageFinance';

export default GarageFinance;



// WEBPACK FOOTER //
// ./src/components/GarageFinance/GarageFinance.jsx